export default "__VITE_PUBLIC_ASSET__5faa3918__"